export const INTENT_TAXONOMY_VERSION = "2026-05-25.v1";

export type CustomerIntent =
  | "chat_now"
  | "kundali_report"
  | "marriage"
  | "career"
  | "health"
  | "finance"
  | "remedy_dosha"
  | "timing"
  | "low_intent"
  | "unknown";

export type IntentMatcher = {
  intent: CustomerIntent;
  terms: string[];
};

export const TEXT_INTENT_MATCHERS: IntentMatcher[] = [
  { intent: "marriage", terms: ["marriage", "match", "compatibility", "vivah", "shaadi"] },
  { intent: "career", terms: ["career", "job", "business", "profession"] },
  { intent: "health", terms: ["health", "disease", "medical"] },
  { intent: "finance", terms: ["finance", "money", "wealth", "loan"] },
  {
    intent: "remedy_dosha",
    terms: [
      "dosha",
      "dosh",
      "upay",
      "remedy",
      "puja",
      "shani",
      "saturn",
      "sade sati",
      "mangal",
      "manglik",
      "rahu",
      "ketu",
      "pitra",
      "kaal sarp",
    ],
  },
  {
    intent: "timing",
    terms: ["muhurat", "panchang", "choghadiya", "rahu kaal", "timing", "auspicious"],
  },
  { intent: "kundali_report", terms: ["kundali", "report", "pdf", "analysis", "forecast"] },
  { intent: "chat_now", terms: ["chat", "question", "answer", "consult", "astrologer"] },
  { intent: "low_intent", terms: ["free", "browse"] },
];

export const CHAT_LANDING_PATHS = new Set(["/ai-astrologer", "/free-astrology-chat"]);
export const REPORT_LANDING_PATHS = new Set(["/free-kundali"]);
export const SESSION_PLAN_IDS = new Set(["quick"]);

export const DOSHA_TEXT_MATCHERS: Array<{ doshaId: string; terms: string[] }> = [
  { doshaId: "shani_dosh", terms: ["shani", "saturn", "sade sati"] },
  { doshaId: "mangal_dosh", terms: ["mangal", "manglik", "mars"] },
  { doshaId: "kaal_sarp_dosh", terms: ["kaal sarp", "kaal-sarp"] },
  { doshaId: "pitra_dosh", terms: ["pitra", "pitru", "ancestor"] },
  { doshaId: "rahu_dosh", terms: ["rahu"] },
  { doshaId: "ketu_dosh", terms: ["ketu"] },
];
